<template>
  <div>
    <p class="text-h4 text-sm-h4 sub-title">Coordonnées du lieu de résidence</p>
    <!-- Adresse -->
    <CanadaPost
      :text="canadaPostLabel"
      clef="contactDeBase"
      required
      cssClass="cssRequired"
      v-model="renseignementsGeneraux.adresse"
      @updateAdresse="updateRenseignementGenerauxAddress"
      @manualEntry="updateAdresseFromManualEntry"
    />

    <!-- Code Postal -->
    <v-text-field
      v-model="renseignementsGeneraux.codePostal"
      :rules="rules.postalCode"
      label="Code Postal"
      required
      class="cssRequired"
    ></v-text-field>
    <!-- Ville -->
    <v-text-field v-model="renseignementsGeneraux.ville" :rules="rules.ville" label="Ville" required class="cssRequired"></v-text-field>
    <!-- Province -->
    <v-autocomplete
      v-model="renseignementsGeneraux.provinceOuEtatSiApplicable"
      :items="listeProvincesFilter"
      :item-text="itemText"
      :item-value="itemValue"
      label="Province ou État si applicable"
      :rules="rules.provinceOuEtatSiApplicable"
      required
      class="cssRequired"
      return-object
      @change="modelChange()"
    ></v-autocomplete>
    <!-- Pays -->
    <v-autocomplete
      v-model="renseignementsGeneraux.pays"
      :items="listePays"
      :item-text="itemText"
      :item-value="itemValue"
      label="Pays"
      @change="paysChange()"
      :rules="rules.pays"
      required
      class="cssRequired"
      return-object
    ></v-autocomplete>

    <!-- Cellulaire -->
    <v-phone-input 
      v-model="renseignementsGeneraux.cellulaire"
      :label="cellulaireLabel"
      :rules="rules.cellulaire"
    ></v-phone-input>

    <!-- Telephone -->
    <v-phone-input 
      v-model="renseignementsGeneraux.telephoneResidence"
      label="Téléphone résidentiel"
      :rules="rules.telephone"
    ></v-phone-input>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import CanadaPost from "../common/canadaPost/CanadaPost"

export default {
  components: {
    CanadaPost: CanadaPost,
  },
  props: {
    renseignementsGeneraux: Object,
    rules: Object,
    isDemandeAdmissionPublique: {
      type: Boolean,
      default: false
    },
    hideEmail: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateMenu: false,
      canadaPostLabel: "Adresse",
      activePicker: null
    }
  },
  created() {
    this.fetchItems()
  },
  computed: {
    ...mapGetters({
      listeProvinces: "Catalogue/GET_PROVINCES",
      listePays: "Catalogue/GET_PAYS"
    }),
    cellulaireLabel() {
      return this.isDemandeAdmissionPublique == true ? "Téléphone" : "Cellulaire"
    },
    listeProvincesFilter() {
      return this.listeProvinces.filter((p) => this.renseignementsGeneraux.pays != null && p.parent == this.renseignementsGeneraux.pays.id)
    }
  },
  watch: {
    dateMenu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"))
    }
  },
  methods: {
    ...mapMutations({
      updateAddressFromCanadaPost: "RenseignementsGeneraux/updateAddressFromCanadaPost",
      updateAddressFromCanadaPostWithManualEntry: "RenseignementsGeneraux/updateAddressFromCanadaPostWithManualEntry",
      setRenseignementsGeneraux: "RenseignementsGeneraux/setRenseignementsGeneraux"
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue"
    }),
    async fetchItems() {
      // Catalogue Province
      await this.getCatalogue(313)
      // Catalogue Pays
      await this.getCatalogue(303)
      if (this.renseignementsGeneraux.pays == null) {
        this.renseignementsGeneraux.pays = this.listePays.find((p) => p.id === this.$catalogues.pays.canada)
      }

      if (this.renseignementsGeneraux.provinceOuEtatSiApplicable == null && this.renseignementsGeneraux.pays.id === this.$catalogues.pays.canada) {
        this.renseignementsGeneraux.provinceOuEtatSiApplicable = this.listeProvinces.find((p) => p.id === this.$catalogues.province.quebec)
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    save(date) {
      this.$refs.menu.save(date)
    },
    validate() {
      this.setRenseignementsGeneraux(this.renseignementsGeneraux)
      this.$emit("validate-form")
    },
    modelChange() {
      this.$nextTick(() => {
        this.model = null
      })
    },
    paysChange() {
      this.modelChange()
      this.renseignementsGeneraux.provinceOuEtatSiApplicable = null
      this.validate()
    },
    updateRenseignementGenerauxAddress(payload) {
      this.updateAddressFromCanadaPost({ address: payload, listePays: this.listePays, listeProvinces: this.listeProvinces })
    },
    updateAdresseFromManualEntry(payload) {
      this.updateAddressFromCanadaPostWithManualEntry({ address: payload })
    }
  }
}
</script>

<style>
</style>